export const API_ENDPOINT ='https://api.tomorder.jp/v1';
export const WEBSITE = 'https://cms.tomorder.jp'
export default {
	API_ENDPOINT,
	WEBSITE,
}